/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, Switch } from 'react-router-dom';
import cn from 'classnames';

import PanelContainer from '../../components/PanelContainer';
import PanelContainerMobile from '../../components/PanelContainerMobile';
import Routes, { getSubRoutes } from '../../components/Routes';
import { setLoading } from '../../redux/loading/loadingActions';
import { appsActions } from '../../redux/reducers/apps';
import { HeadWrapper } from '../../elements';
import NotFound from '../notfound/NotFound';
import Button from '../../elements/Button/Button';
import { ReactComponent as ArrowBack } from '../../styles/icon/arrow-back.svg';
import { ReactComponent as Key } from '../../styles/icon/key.svg';
import { ReactComponent as CheckCircle } from '../../styles/icon/check-circle.svg';
import { ReactComponent as Webhook } from '../../styles/icon/webhook-grey.svg';
import { Mobile, DesktopAndTablet } from '../../utils/responsiveQueries';
import { useAppDispatch } from '../../hooks/useRedux';
import strings from '../../lang/lang';

import settings from './Settings.module.scss';
import GenerateSecretModal from './GenerateSecretModal';
import DeleteAppModal from './DeleteAppModal';

function AppSpace(props) {
  const { match, history, location } = props;
  const [errorMessage, setError] = useState('');
  const [appId] = useState(match.params.id);
  const [name, setName] = useState('');

  const pathName = location.pathname;
  const dispatch = useAppDispatch();
  const loading = useSelector((state) => state.loading);

  useEffect(() => {
    setLoading(true);
    getAppDetails();
  }, [appId]);

  function getAppDetails() {
    return new Promise<any>((res, rej) => {
      dispatch(appsActions.loadAppDetails({ id: appId, res, rej }));
    })
    .then((res) => {
      const name = res.data.name || '';
      setName(name);
    })
    .catch(({ data }) => {
      const id = data.traceId || '';
      setError('Oooops some error occurred. Please connect to support. Specify request Id = ' + id);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  if (match.isExact) {
    history.push(Routes.routes.APPS.routes.CREDENTIALS.path.replace(':id', appId));
    return <React.Fragment />;
  }
  if (!name) {
    if (loading) {
      return <React.Fragment />;
    } else if (errorMessage) {
      return <NotFound message={errorMessage} />;
    } else {
      return null;
    }
  }

  return (
    <Fragment>
      <HeadWrapper
        href={`https://developer.staq.io${pathName}`}
      />
      <DesktopAndTablet>
        <PanelContainer />
      </DesktopAndTablet>
      <Mobile>
        <PanelContainerMobile />
      </Mobile>
      <DeleteAppModal />
      <GenerateSecretModal />
      <div className={settings.settings}>
        <div className={settings.settings__box}>
          <DesktopAndTablet>
            <div className={settings.settings__back}>
              <Link to={Routes.routes.APPLIST.path}>
                <Button name={strings.appSpace.buttons.back} variant="back">
                  <ArrowBack />
                </Button>
              </Link>
            </div>
          </DesktopAndTablet>
          <div className={settings.settings__container}>
            <h1>{strings.appSpace.text.title}</h1>
            <div className={settings.settings__tabs}>
              <Link
                className={cn(settings.settings__link, {
                  [settings['settings__active']]: location.pathname.indexOf('credent') !== -1,
                })}
                to={Routes.routes.APPS.routes.CREDENTIALS.path.replace(':id', appId)}
              >
                <Key />
                <span>{strings.appSpace.text.credentials}</span>
              </Link>
              <Link
                className={cn(settings.settings__link, {
                  [settings['settings__active']]: location.pathname.indexOf('permiss') !== -1,
                })}
                to={Routes.routes.APPS.routes.PERMISSIONS.path.replace(':id', appId)}
              >
                <CheckCircle />
                <span>{strings.appSpace.text.permissions}</span>
              </Link>
              <Link
                  className={cn(settings.settings__link, {
                    [settings['settings__active']]: location.pathname.indexOf('webhook') !== -1,
                  })}
                  to={Routes.routes.APPS.routes.WEBHOOKS.path.replace(':id', appId)}
              >
                <Webhook />
                <span>{strings.appSpace.text.webhooks}</span>
              </Link>
            </div>
            <div>
              <Switch>{getSubRoutes(Routes.routes.APPS)}</Switch>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}



export default AppSpace;
